<section class="not-found">
    <span [translate]="'painel-dashboard/no-results'">No results found</span>
</section>